import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('userId');
    if (token && userId) {
      return {
        token,
        userId,
        name: localStorage.getItem('name'),
        role: localStorage.getItem('role'),
        team: localStorage.getItem('team') || localStorage.getItem('role'),
        permissions: JSON.parse(localStorage.getItem('permissions') || '[]'),
      };
    }
    return null;
  });

  const login = (data) => {
    localStorage.setItem('token', data.token);
    localStorage.setItem('userId', data.userId);
    localStorage.setItem('name', data.name);
    localStorage.setItem('role', data.role);
    localStorage.setItem('team', data.team || data.role);
    localStorage.setItem('permissions', JSON.stringify(data.permissions || []));
    setUser({ ...data, team: data.team || data.role, permissions: data.permissions || [] });
  };

  const logout = () => {
    localStorage.clear();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
